(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-extended"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const forms = document.querySelectorAll('.contact-extended__form');
    if (!forms.length) return;

    forms.forEach((form) => {
      // Conditional groups: a group with data-reveal-when appears only while
      // a choice elsewhere in the form with that label is selected.
      form.querySelectorAll('.form-checkbox-group[data-reveal-when]').forEach((group) => {
        const wanted = group.dataset.revealWhen.trim().toLowerCase();
        const triggers = [...form.querySelectorAll('.form-checkbox-group__option')].filter(
          (opt) => !group.contains(opt) && opt.textContent.trim().toLowerCase() === wanted
        );
        if (!triggers.length) return;
        const update = () => {
          const on = triggers.some((opt) => opt.querySelector('input').checked);
          group.hidden = !on;
          if (!on) group.querySelectorAll('input:checked').forEach((cb) => (cb.checked = false));
        };
        triggers.forEach((opt) => opt.querySelector('input').addEventListener('change', update));
        update();
      });

      // Default the country-code select from the visitor's locale region,
      // falling back to their timezone; combine code + number on submit.
      const dial = form.querySelector('.contact-extended__dial');
      const tel = form.querySelector('input[type="tel"]');
      if (dial && tel) {
        const TZ = {
          Australia: 'AU', Auckland: 'NZ', London: 'GB', Dublin: 'IE',
          Moscow: 'RU', Tokyo: 'JP', Seoul: 'KR', Singapore: 'SG',
          Jakarta: 'ID', Makassar: 'ID', Bangkok: 'TH', Dubai: 'AE',
          Kolkata: 'IN', Hong_Kong: 'HK', Taipei: 'TW', Manila: 'PH',
          Kuala_Lumpur: 'MY', Mexico_City: 'MX', Sao_Paulo: 'BR',
          Buenos_Aires: 'AR', Johannesburg: 'ZA', Nairobi: 'KE',
          Toronto: 'CA', Vancouver: 'CA', Berlin: 'DE', Paris: 'FR',
          Madrid: 'ES', Rome: 'IT', Amsterdam: 'NL', Zurich: 'CH'
        };
        let region;
        try {
          region = new Intl.Locale(navigator.language).region;
        } catch (e) {
          region = undefined;
        }
        if (!region) {
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
          const hit = Object.keys(TZ).find((part) => tz.includes(part));
          if (hit) region = TZ[hit];
          else if (tz.startsWith('America/')) region = 'US';
        }
        if (region) {
          const match = [...dial.options].find((o) => o.dataset.region === region);
          if (match) dial.value = match.value;
        }
        form.addEventListener('submit', () => {
          const number = tel.value.trim();
          if (number && !number.startsWith('+')) {
            tel.value = dial.value + ' ' + number;
          }
        });
      }

      // Submit in place: spinner on the button, then the success panel swaps
      // in where the form was. The old full-page POST reloaded to the top of
      // the page and buried the slim banner, which read on a phone as the
      // page scrolling away uncontrollably (owner report, 2026-10-12).
      // Shopify's spam challenge and any unexpected response fall back to
      // the native POST, which still works without this handler.
      const panel = form.querySelector('[data-contact-success]');
      const fieldsWrap = form.querySelector('[data-contact-fields]');
      const submitButton = form.querySelector('.contact-extended__submit');
      if (panel && fieldsWrap && submitButton) {
        let busy = false;
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (busy) return;
          busy = true;
          const label = submitButton.querySelector('.contact-extended__submit-label');
          const restingLabel = label.textContent;
          submitButton.disabled = true;
          submitButton.classList.add('is-loading');
          submitButton.setAttribute('aria-busy', 'true');
          label.textContent = submitButton.dataset.sendingLabel || restingLabel;
          try {
            const response = await fetch(form.action, {
              method: 'POST',
              body: new FormData(form),
              headers: { Accept: 'text/html' },
            });
            if (!response.ok || response.url.includes('/challenge')) throw new Error('fallback');
            const text = await response.text();
            if (text.includes('contact-extended__error')) throw new Error('fallback');
            fieldsWrap.hidden = true;
            panel.hidden = false;
            panel.focus({ preventScroll: true });
            panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (error) {
            busy = false;
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
            submitButton.removeAttribute('aria-busy');
            label.textContent = restingLabel;
            form.submit();
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guides-carousel"] && !Shopify.designMode) return;
  try {
    
  class OlgaCarousel extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.guides-carousel__rail');
      this.querySelectorAll('.guides-carousel__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = this.rail.querySelector('.guide-card__item');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 40;
          const step = (card.getBoundingClientRect().width + gap) * Number(btn.dataset.dir);
          this.rail.scrollBy({ left: step, behavior: 'smooth' });
        });
      });
      this.rail.addEventListener(
        'scroll',
        () => this.classList.add('guides-carousel--scrolled'),
        { once: true, passive: true }
      );
    }
  }

  if (!customElements.get('olga-carousel')) {
    customElements.define('olga-carousel', OlgaCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('olga-gallery')) {
    customElements.define(
      'olga-gallery',
      class OlgaGallery extends HTMLElement {
        connectedCallback() {
          if (this.classList.contains('image-gallery--mosaic')) this.initMosaic();
          if (!this.hasAttribute('data-lightbox')) return;
          this.dialog = this.querySelector('[data-gallery-dialog]');
          this.dialogImg = this.querySelector('[data-gallery-dialog-img]');
          this.addEventListener('click', this.onClick.bind(this));
        }

        disconnectedCallback() {
          if (this.onMosaicResize) window.removeEventListener('resize', this.onMosaicResize);
        }

        initMosaic() {
          this.mosaicFigures = [...this.querySelectorAll('figure.gallery-image')];
          if (!this.mosaicFigures.length) return;
          this.mosaicTarget = null;
          this.groupMosaicRows();
          this.onMosaicResize = () => {
            cancelAnimationFrame(this.mosaicRaf);
            this.mosaicRaf = requestAnimationFrame(() => this.groupMosaicRows());
          };
          window.addEventListener('resize', this.onMosaicResize);
        }

        // Justified rows like the original Tilda gallery: widths within a row are
        // proportional to each photograph's aspect ratio (flex-grow = ratio), so
        // every tile in the row shares one height. A row closes once its summed
        // ratio passes the target: 3.4 on desktop reproduces the original's
        // 4-then-2 rhythm, 1.15 on phones its 1/2/1/2 stack.
        groupMosaicRows() {
          const target = window.innerWidth >= 750 ? 3.4 : 1.15;
          if (target === this.mosaicTarget) return;
          this.mosaicTarget = target;
          const fragment = document.createDocumentFragment();
          let row = null;
          let sum = 0;
          for (const figure of this.mosaicFigures) {
            const img = figure.querySelector('img');
            const ratio =
              img && Number(img.getAttribute('width')) && Number(img.getAttribute('height'))
                ? Number(img.getAttribute('width')) / Number(img.getAttribute('height'))
                : 1;
            figure.style.flexGrow = ratio;
            figure.style.aspectRatio = ratio;
            if (!row) {
              row = document.createElement('div');
              row.className = 'image-gallery__mosaic-row';
              fragment.appendChild(row);
              sum = 0;
            }
            row.appendChild(figure);
            sum += ratio;
            if (sum >= target) row = null;
          }
          // A photograph left alone in the final row would stretch to the full
          // gallery width (a portrait becomes a monster); fold it into the row
          // above instead.
          const rows = [...fragment.children];
          const lastRow = rows[rows.length - 1];
          if (rows.length > 1 && lastRow.children.length === 1) {
            rows[rows.length - 2].appendChild(lastRow.firstElementChild);
            lastRow.remove();
          }
          this.querySelectorAll('.image-gallery__mosaic-row').forEach((emptyRow) => emptyRow.remove());
          this.insertBefore(fragment, this.querySelector('[data-gallery-dialog]'));
        }

        onClick(event) {
          const closer = event.target.closest('[data-gallery-close]');
          if (closer && this.dialog) {
            this.dialog.close();
            return;
          }

          const trigger = event.target.closest('[data-gallery-trigger]');
          if (!trigger || !this.dialog) return;
          const img = trigger.querySelector('img');
          if (!img) return;
          this.dialogImg.src = trigger.dataset.fullSrc || img.currentSrc || img.src;
          this.dialogImg.alt = img.alt || '';
          this.dialog.showModal();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-cta')) {
    customElements.define('sticky-cta', class extends HTMLElement {
      connectedCallback() {
        this.pastIntro = false;
        this.nearTarget = false;
        const intro = [...document.querySelectorAll('#MainContent .shopify-section')].find(
          (candidate) => !candidate.contains(this)
        );
        const hash = (this.dataset.target || '').split('#')[1];
        const target = hash ? document.getElementById(hash)?.closest('.shopify-section') : null;
        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.target === intro) this.pastIntro = !entry.isIntersecting;
            if (entry.target === target) this.nearTarget = entry.isIntersecting;
          }
          this.hidden = !(this.pastIntro && !this.nearTarget);
        });
        if (intro) this.observer.observe(intro);
        if (target) this.observer.observe(target);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
